module.exports = __webpack_public_path__ + "img/1.5abf0d01.jpg";